import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import TopicCard from '@/components/base/TopicCard';
import { topics } from '@/mocks/gossip';

export default function FeaturedTopics() {
  const [feature, ...rest] = topics;

  return (
    <section id="topics" className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-50">
      <SectionHeading
        eyebrow="精选话题"
        title="值得花十分钟慢慢看的内容"
        desc="不只汇总热闹，也把来龙去脉讲清楚，方便你带着判断参与讨论。"
      />

      <article className="mt-10 grid grid-cols-1 lg:grid-cols-2 gap-0 rounded-lg overflow-hidden border border-background-200 bg-background-100">
        <Link to={`/topic/${feature.id}`} className="block w-full h-64 lg:h-full min-h-[240px] overflow-hidden">
          <img
            src={feature.cover}
            alt={`${feature.title} - 今日精选话题`}
            title={`${feature.title} 福利吃瓜`}
            className="w-full h-full object-cover object-top"
          />
        </Link>
        <div className="p-6 md:p-8 flex flex-col justify-center">
          <span className="inline-flex w-fit items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100 text-accent-900 text-xs mb-4">
            <i className="ri-award-line"></i>
            主编推荐
          </span>
          <h3 className="font-heading text-2xl md:text-3xl text-foreground-950 leading-snug">
            <Link to={`/topic/${feature.id}`} className="hover:text-primary-600 transition-colors">
              {feature.title}
            </Link>
          </h3>
          <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">{feature.excerpt}</p>
          <div className="mt-5 flex flex-wrap items-center gap-4 text-xs text-foreground-500">
            <span className="flex items-center gap-1">
              <i className="ri-user-3-line"></i>
              {feature.author}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {feature.readCount.toLocaleString()} 次阅读
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-chat-3-line"></i>
              {feature.commentCount} 条讨论
            </span>
          </div>
          <Link
            to={`/topic/${feature.id}`}
            className="mt-6 inline-flex w-fit items-center gap-1.5 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm whitespace-nowrap hover:bg-primary-600 transition-colors"
          >
            阅读全文
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </article>

      <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {rest.slice(0, 3).map((topic) => (
          <TopicCard key={topic.id} topic={topic} />
        ))}
      </div>

      <div className="mt-8 flex justify-center">
        <Link
          to="/topics"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-md border border-foreground-900 text-foreground-900 text-sm whitespace-nowrap hover:bg-foreground-900 hover:text-background-50 transition-colors"
        >
          浏览全部 {topics.length} 条话题
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}